// Super_admin-only tab in the per-station admin shell. Edits the current
// station's branding, products, and Stripe configuration via PublisherForm
// in 'edit' mode.
//
// Gating: super_admin only. PublisherAdminLayout only renders the nav item
// for super_admins; direct URL access by other roles redirects to the
// station overview.

import React from 'react';
import { Navigate } from 'react-router-dom';
import { Settings } from 'lucide-react';
import PublisherForm from '../../components/self-service/admin/PublisherForm';
import { usePublisherFormSubmit } from '../../components/self-service/admin/usePublisherFormSubmit';
import { useSingleStationContext } from '../../components/self-service/admin/useAdminContext';
import AdminPageHeader from '../../components/self-service/admin/AdminPageHeader';
import { useAuth } from '../../components/self-service/auth/useAuth';
import { displayedName } from '../../data/publisherConfigs';

const PublisherChannelSettingsPage: React.FC = () => {
  const { config, slug } = useSingleStationContext();
  const { user } = useAuth();
  const handleUpdate = usePublisherFormSubmit('selfservice-update-publisher');

  if (user?.rawRole !== 'super_admin') {
    return <Navigate to={`/admin/${slug}`} replace />;
  }

  return (
    <div className="max-w-4xl">
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-slate-900 text-white text-[10px] font-semibold uppercase tracking-[0.14em] mb-4">
        <Settings className="w-3 h-3" />
        Channel settings
      </div>
      <AdminPageHeader
        title={displayedName(config)}
        scopeMode="bound"
        currentSlug={slug}
        subtitle="Update branding, products, markets, and Stripe configuration for this channel."
      />
      <PublisherForm mode="edit" initial={config} onSubmit={handleUpdate} />
    </div>
  );
};

export default PublisherChannelSettingsPage;
